export default store => {

  store.subscribe((mutation, state) => {
    const anamnesisPersist = state.atencionCita.anamnesis;
    localStorage.setItem('crearAnamnesis', JSON.stringify(anamnesisPersist));

    const recetaPersist = state.atencionCita.receta.medicamentosList;
    localStorage.setItem('atencionReceta', JSON.stringify(recetaPersist));

    const atencionImagenesPersist = state.atencionCita.imagenes.imagenesList;
    localStorage.setItem('atencionImagenes', JSON.stringify(atencionImagenesPersist));

    const atencionLaboratoriosPersist = state.atencionCita.laboratorios.laboratorioList;
    localStorage.setItem('atencionLaboratorios', JSON.stringify(atencionLaboratoriosPersist));

    // const atencionTerapiasPersist = state.atencionCita.terapias.terapiasList;
    // localStorage.setItem('atencionTerapias', JSON.stringify(atencionTerapiasPersist));

    const comentariosAuditoriaPersist = state.comentarios;
    localStorage.setItem('comentarios', JSON.stringify(comentariosAuditoriaPersist))
  });
};


